export enum vuaIdSuffix {
  value = "@pbfinaa",
}
